import { render, staticRenderFns } from "./publishUpdate.vue?vue&type=template&id=71e2d41a&"
import script from "./publishUpdate.vue?vue&type=script&lang=js&"
export * from "./publishUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports